import { render, staticRenderFns } from "./Auth_Form.vue?vue&type=template&id=2d8ab0dd&"
import script from "./Auth_Form.vue?vue&type=script&lang=js&"
export * from "./Auth_Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports